module.exports = __webpack_public_path__ + "img/Profile face Icon - charcoal.25e2d5bf.svg";